// Angular Files
import { Injectable } from '@angular/core';

// Other External Files
import { firstValueFrom } from 'rxjs';

// Teller Online Files
import {
    LinkedAccountDto,
    LinkedAccountsApiClient,
    UnlinkLinkedAccountRequestDto
} from 'apps/admin-portal/src/app/core/api/AdminPortalApiClients';

@Injectable({
    providedIn: 'root'
})
export class AdminLinkedAccountsService {
    constructor(private linkedAccountsApiClient: LinkedAccountsApiClient) {
    }

    public async getLinkedAccounts(userId: number): Promise<LinkedAccountDto[]> {
        // The generated client resolves null rather than failing while the browser is offline,
        // and callers are entitled to a list.
        const accounts = await firstValueFrom(
            this.linkedAccountsApiClient.getUserLinkedAccounts(userId)
        );

        return accounts ?? [];
    }

    public unlinkAccount(
        userId: number,
        linkedAccountId: number,
        reason: string
    ): Promise<void> {
        return firstValueFrom(this.linkedAccountsApiClient.unlinkUserLinkedAccount(
            userId,
            linkedAccountId,
            new UnlinkLinkedAccountRequestDto({ reason })
        ));
    }
}
